import { useAuth } from '../../contexts/AuthProvider';
import { Col, Row } from 'react-bootstrap';
import { PageContainer } from '../../components/PageContainer';
import { AppLink } from '../../interfaces/app-link.interface';
import { baseURL } from '../../constants/config';
import { Link } from 'react-router';
import { RoutesEnum } from '../../routes/routes.enum';

export default function Dashboard() {
  const { authInfo } = useAuth();
  const appPages: AppLink[] = [
    {
      title: 'Purchase Order',
      url: RoutesEnum.PurchaseOrderList,
      variant: 'primary',
    },
    {
      title: 'Sale Order',
      url: RoutesEnum.SaleOrderList,
      variant: 'danger',
    },
    {
      title: 'Purchase Order Balance Report',
      url: RoutesEnum.PurchaseOrderItemBalance,
      variant: 'secondary',
    },
    // {
    //   title: 'Sale Order Balance Report',
    //   url: RoutesEnum.SaleOrderItemBalance,
    //   variant: 'success',
    // },
    {
      title: 'Account Trial Balance',
      url: RoutesEnum.AccountTrialBalance,
      variant: 'info',
    },
    {
      title: 'Agent Account Balances',
      url: RoutesEnum.AgentAccountTrialBalance,
    },
  ];

  return (
    <PageContainer title="Dashboard" body={
      <>
        <Row>
          <Col><h2>Welcome {authInfo.user.name}!</h2></Col>
        </Row>
        <Row>
          {appPages.map(({ title, url, variant }, index) => (
            <Col className='mb-4' sm={6} key={'dashboard-link-' + index}>
              <Link className={`btn btn-${variant ?? 'info'} w-100 py-4 fs-5`} to={`${baseURL}${url}`}>{title}</Link>
            </Col>
          ))}
        </Row>
      </>
    } />
  );
};